export default {
  VoucherResult: 'Kết quả thực hiện',
  Cancel: 'Hủy',
  Build: 'Cất',
  BuildShortKey: 'Cất (Ctrl + S)',
  ExportExcel: 'Xuất Excel',
};
